// @module NVT.MyRegisterColleague.MyTermsConditions
define('NVT.MyRegisterColleague.MyTermsConditions.View'
,	[
		'nvt_term_condition.tpl'
		
	,	'Backbone'

	,	'GlobalViews.Confirmation.View'

	,	'NVT.MyRegisterColleague.MyTermsConditions.View'

	,	'Utils'

    ]
, function (
		nvt_term_condition_tpl
		
	,	Backbone

	, 	GlobalViewsConfirmationView

	,	MyTermsConditionsView

	,	Utils

)
{
    'use strict';

	// @class NVT.MyRegisterColleague.MyTermsConditions.View @extends Backbone.View
	return Backbone.View.extend({

		template: nvt_term_condition_tpl

	,	initialize: function (options) {
			this.options = options;
			this.container = options.container;
			this.layout = this.container.getComponent('Layout');
			this.pdp = this.container.getComponent('PDP');
			var self = this;
		}

	,	events: {
				'click button[data-action="data-action-terms-condition"]': 'dataActionTermsCondition'
		}

	,	dataActionTermsCondition : function(e){
			var self = this;
			if (this.layout) {
					
				var modalMessage = new MyTermsConditionsView({ container: this.container,getteramconditiondDetails: this.pdp.getItemInfo() ? self.pdp.getItemInfo().item.custitem_nus_ems_tc : '' });
					modalMessage.modalClass ='modal-md';
					modalMessage.title = 'Terms and Conditions';
					this.options.container.layout.showInModal(modalMessage);
				return false;
			}		
		}

	,	bindings: {

		}

	, 	childViews: {

		}

		//@method getContext @return NVT.MyRegisterColleague.MyTermsConditions.View.Context
	,	getContext: function getContext()
		{
			var self = this;		
			
			return {
				getteramcondition : this.pdp.getItemInfo() ? this.pdp.getItemInfo().item.custitem_nus_ems_tc : '' ,
				getteramconditiondDetails :  this.options.getteramconditiondDetails || '' ,				
			}
		}
	});
});
